import DragAndDropZone from '@Components/DocumentUploadForm/DragAndDropZone'
import React, { RefObject } from 'react'
import './index.scss'

interface UploadSelectionSectionProps {
    onFilesChosen: (files: FileList | null, allowMultipleUploads: boolean) => void
    maxFileSizeString: string
    uploadFileTypesString: string
    allowMultipleUploads: boolean
    browseFilesButtonText: string
    browseFilePickerRef: RefObject<HTMLInputElement | null>
}

const UploadSelectionSection = ({
    onFilesChosen,
    maxFileSizeString,
    uploadFileTypesString,
    allowMultipleUploads,
    browseFilesButtonText,
    browseFilePickerRef,
}: UploadSelectionSectionProps) => (
    <>
        <div className="upload-and-submit">
            <DragAndDropZone
                onFilesChosen={onFilesChosen}
                maxFileSizeString={maxFileSizeString}
                uploadFileTypesString={uploadFileTypesString}
                allowMultipleUploads={allowMultipleUploads}
            />
            <label className="browse-files-label" htmlFor="browse-file-picker">
                {browseFilesButtonText}
            </label>
        </div>
        <input
            ref={browseFilePickerRef}
            id="browse-file-picker"
            className="browse-files-button"
            type="file"
            name="browse-files"
            multiple={allowMultipleUploads}
            onChange={(e) => onFilesChosen(e.target.files, allowMultipleUploads)}
            hidden
        />
    </>
)

export default UploadSelectionSection
